var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.7135 28.2966V31.6802H39.9989L39.3203 36.2382H35.7135V46.7396C34.9903 46.8375 34.2505 46.8887 33.4994 46.8887C32.6326 46.8887 31.7813 46.8212 30.9523 46.6906V36.2382H27V31.6802H30.9523V27.5402C30.9523 24.9717 33.0838 22.8887 35.7146 22.8887V22.8908C35.7224 22.8908 35.7291 22.8887 35.7369 22.8887H40V26.8306H37.2144C36.3865 26.8306 35.7146 27.4869 35.7146 28.2955L35.7135 28.2966Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 33.5,
    cy: 34.3887,
    r: 33,
    stroke: "#303030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social-facebook.59eb186a04c908cae65c105fca21198916e78b9423bbf648b8fdfe41ad759312.svg";
export { ForwardRef as ReactComponent };